import { render, staticRenderFns } from "./ModelCard.vue?vue&type=template&id=70d58c62&scoped=true&"
import script from "./ModelCard.vue?vue&type=script&lang=js&"
export * from "./ModelCard.vue?vue&type=script&lang=js&"
import style0 from "./ModelCard.vue?vue&type=style&index=0&id=70d58c62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d58c62",
  null
  
)

export default component.exports